import React from 'react';

function NewsletterSection() {
  return (
    <section className="bg-[#1E3A5F] text-white py-12">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl font-bold font-montserrat mb-4">Suscríbete para recibir información, últimas noticias y otras ofertas interesantes</h2>
        <form className="flex justify-center">
          <input type="email" placeholder="Tú correo electrónico" className="rounded-l-full px-6 py-3 border-none focus:outline-none" />
          <button type="submit" className="bg-[#2AA8B0] rounded-r-full px-6 py-3 text-white font-semibold hover:bg-[#1E3A5F] transition-colors duration-300">
            Enviar
          </button>
        </form>
      </div>
    </section>
  );
}

export default NewsletterSection;